/*
 * Module for the 'change password' modal
 */

// noinspection JSUnusedLocalSymbols
define([
  "marionette",
  "jquery",
  "messaging/messenger",
  "modules/admin/userAdmin/passwordAdmin/passwordAdminView",
  "modules/admin/userAdmin/passwordAdmin/passwordAdminModel",
  "modules/admin/userAdministration/usersModel",
], function (Marionette, $, Messenger, PasswordAdminView, PasswordAdminModel) {
  var PasswordAdminModule = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "passwordAdmin";
      this.region = options.region;
      this.tenant = options.tenant;
      this.preventCancel = !!options.preventCancel;
    },
    show: function () {
      if (!this.tenant) {
        this.tenant = Messenger.reqres.request("active:tenant");
      }
      this.tenant.onSynced(function () {
        this.tenant.preventCancel = this.preventCancel;
        this.view = new PasswordAdminView.passwordAdminView({
          model: this.tenant,
        });

        this.view.on(
          "done",
          function () {
            //clear any existing errors
            this.view.clearErrors();
            //get the passwords from the inputs
            var oldPassword = this.view.getOldPassword();
            var newPassword = this.view.getNewPassword();
            var reenterPassword = this.view.getReenterPassword();
            //check the inputs for errors
            var isError = this._evaluatePasswords(oldPassword, newPassword, reenterPassword);
            // if the inputs are clean, save the new password, update Backbone BasicAuth with the new password and close the modal
            if (!isError) {
              //create a model to save this
              var updatePasswordModel = new PasswordAdminModel.passwordAdminModel();
              updatePasswordModel.setOldPassword(oldPassword);
              updatePasswordModel.setNewPassword(newPassword);
              updatePasswordModel.saveModel({
                success: function () {
                  Messenger.saveAttempted(true);
                  Messenger.vent.trigger("close:modal");
                },
              });
            }
          },
          this,
        );

        this.view.on(
          "cancel",
          function () {
            Messenger.vent.trigger("close:modal");
          },
          this,
        );

        this.showRegion(this.view);
      }, this);
    },
    _evaluatePasswords: function (oldPassword, newPassword, reenterPassword) {
      var user = Messenger.reqres.request("user");
      var isError = false;
      //old password validation
      if (!oldPassword || oldPassword.length === 0) {
        //if the oldPassword is empty, show the missing password error
        isError = true;
        this.view.setOldPasswordError($.t("user.missingPassword"));
      }
      //new password validation
      var newPasswordError = Messenger.reqres.request("user:validatePassword", {
        userLogin: user.get("loginName"),
        password: newPassword,
        userFullName: user.get("userName"),
      });
      if (newPasswordError) {
        isError = true;
        this.view.setNewPasswordError(newPasswordError);
      }

      //re-entered password validation
      if (!reenterPassword || reenterPassword.length === 0) {
        //if the reenterPassword is empty, show the missing password error
        isError = true;
        this.view.setReenterPasswordError($.t("user.missingPassword"));
      } else if (newPassword !== reenterPassword) {
        //if the new password does not match the reentered password
        isError = true;
        this.view.setReenterPasswordError($.t("user.passwordMismatch"));
      }

      return isError;
    },
  });

  return PasswordAdminModule;
});
